(function () {
  "use strict";

  var _currentModal = null;
  var _isClosing = false;

  function init() {
    document.addEventListener("click", handleClick);
    document.addEventListener("keydown", handleEscape);
  }

  function handleClick(evt) {
    if (_isClosing) return;

    var closeBtn = evt.target.closest(".js-quick-add-modal-close");
    if (closeBtn) {
      if (_currentModal) closeModal(_currentModal);
      return;
    }

    var openBtn = evt.target.closest(".js-quick-add-to-cart");
    if (openBtn) {
      evt.preventDefault();
      evt.stopPropagation();
      var productId = openBtn.getAttribute("data-product-id");
      var modal = document.getElementById("QuickAddModal-" + productId);
      if (modal) openModal(modal, productId);
      return;
    }

    if (_currentModal) {
      if (
        !evt.target.closest(".drawer__contents") &&
        !evt.target.closest(".quick-add-modal__content")
      ) {
        closeModal(_currentModal);
      }
    }
  }

  function handleEscape(evt) {
    if (evt.key !== "Escape" || _isClosing) return;
    if (_currentModal) closeModal(_currentModal);
  }

  function openModal(modal, productId) {
    if (_currentModal === modal) return;
    if (_currentModal) closeModal(_currentModal);

    if (!modal._qaOriginalParent) {
      modal._qaOriginalParent = modal.parentNode;
      modal._qaOriginalNextSibling = modal.nextSibling;
    }
    document.body.appendChild(modal);

    modal.classList.remove("is-transitioning");
    modal.classList.add("drawer--is-open");
    modal.setAttribute("aria-hidden", "false");
    document.documentElement.classList.add("js-drawer-open");
    document.documentElement.classList.remove("js-drawer-closing");

    _currentModal = modal;
    _isClosing = false;

    initVariantLogic(modal, productId);
    initPlayerSelect(modal, productId);
    initFormSubmit(modal, productId);
    initCarousel(modal, productId);
  }

  function closeModal(modal) {
    if (!modal || _isClosing) return;
    _isClosing = true;
    _currentModal = null;

    try {
      document.activeElement.blur();
    } catch (e) {}

    modal.classList.remove("drawer--is-open");
    modal.classList.remove("is-transitioning");
    modal.setAttribute("aria-hidden", "true");
    document.documentElement.classList.remove("js-drawer-open");
    document.documentElement.classList.add("js-drawer-closing");

    resetModal(modal);

    setTimeout(function () {
      document.documentElement.classList.remove("js-drawer-closing");
      restoreModalPosition(modal);
      _isClosing = false;
    }, 500);
  }

  function restoreModalPosition(modal) {
    try {
      if (modal._qaOriginalParent) {
        if (
          modal._qaOriginalNextSibling &&
          modal._qaOriginalNextSibling.parentNode === modal._qaOriginalParent
        ) {
          modal._qaOriginalParent.insertBefore(
            modal,
            modal._qaOriginalNextSibling,
          );
        } else {
          modal._qaOriginalParent.appendChild(modal);
        }
      }
    } catch (e) {}
  }

  function resetModal(modal) {
    var productId = modal.id.replace("QuickAddModal-", "");

    var playerSelect = modal.querySelector(
      '[class*="quick-add-modal__player-select"]',
    );
    if (playerSelect) {
      playerSelect.selectedIndex = 0;
    }

    var nameInput = modal.querySelector(
      '[data-quick-add-custom-name="' + productId + '"]',
    );
    var numberInput = modal.querySelector(
      '[data-quick-add-custom-number="' + productId + '"]',
    );
    if (nameInput) nameInput.value = "";
    if (numberInput) numberInput.value = "";

    var sizeRadios = modal.querySelectorAll(
      'input[data-quick-add-option="' + productId + '"]:not([type="hidden"])',
    );
    sizeRadios.forEach(function (radio) {
      radio.checked = radio.defaultChecked;
    });

    var priceEl = modal.querySelector(
      '[data-quick-add-price="' + productId + '"]',
    );
    if (priceEl && priceEl._qaOriginalPriceHtml !== undefined) {
      priceEl.innerHTML = priceEl._qaOriginalPriceHtml;
    }
  }

  function getVariants(productId) {
    var textarea = document.querySelector(
      '[data-quick-add-variants="' + productId + '"]',
    );
    if (!textarea) return [];
    try {
      return JSON.parse(textarea.value);
    } catch (e) {
      return [];
    }
  }

  function initVariantLogic(modal, productId) {
    var radios = modal.querySelectorAll(
      '[data-quick-add-option="' + productId + '"]',
    );
    var variants = getVariants(productId);

    var priceEl = modal.querySelector(
      '[data-quick-add-price="' + productId + '"]',
    );
    if (priceEl && priceEl._qaOriginalPriceHtml === undefined) {
      priceEl._qaOriginalPriceHtml = priceEl.innerHTML;
    }

    radios.forEach(function (radio) {
      radio.removeEventListener("change", radio._quickAddHandler);

      radio._quickAddHandler = function () {
        updateSelectedVariant(modal, productId, variants);
        updateAvailability(modal, productId, variants);
      };

      radio.addEventListener("change", radio._quickAddHandler);
    });

    updateSelectedVariant(modal, productId, variants);
    updateAvailability(modal, productId, variants);
  }

  function getSelectedOptions(modal, productId) {
    var options = [];
    var fieldsets = modal.querySelectorAll("[data-option-position]");

    fieldsets.forEach(function (fieldset) {
      var checked = fieldset.querySelector(
        'input[data-quick-add-option="' + productId + '"]:checked',
      );
      if (checked) {
        options.push(checked.value);
      }
    });

    return options;
  }

  function findVariant(variants, selectedOptions) {
    return variants.find(function (variant) {
      return variant.options.every(function (opt, i) {
        return opt === selectedOptions[i];
      });
    });
  }

  function updateSelectedVariant(modal, productId, variants) {
    var selectedOptions = getSelectedOptions(modal, productId);
    var variant = findVariant(variants, selectedOptions);

    var variantInput = modal.querySelector(
      '[data-quick-add-variant-input="' + productId + '"]',
    );
    var submitBtn = modal.querySelector(
      '[data-quick-add-submit="' + productId + '"]',
    );
    var submitText = modal.querySelector(
      '[data-quick-add-submit-text="' + productId + '"]',
    );
    var priceEl = modal.querySelector(
      '[data-quick-add-price="' + productId + '"]',
    );
    var imageEl = modal.querySelector(
      '[data-quick-add-image="' + productId + '"]',
    );

    var colorLabels = modal.querySelectorAll("[data-quick-add-color-label]");
    colorLabels.forEach(function (label) {
      var position = label
        .getAttribute("data-quick-add-color-label")
        .replace(productId + "-", "");
      var fieldset = modal.querySelector(
        '[data-option-position="' + position + '"]',
      );
      if (fieldset) {
        var checked = fieldset.querySelector("input:checked");
        if (checked) {
          label.textContent = "— " + checked.value;
        }
      }
    });

    if (variant) {
      variantInput.value = variant.id;

      if (!variant.available) {
        submitBtn.setAttribute("disabled", "disabled");
        submitText.textContent = theme.strings.soldOut || "Sold out";
      } else if (variant.price === 0) {
        submitBtn.setAttribute("disabled", "disabled");
        submitText.textContent = theme.strings.soldOut || "Sold out";
      } else {
        submitBtn.removeAttribute("disabled");
        submitText.textContent = theme.strings.addToCart || "Add to cart";
      }

      if (priceEl) {
        var priceHtml = "";
        if (variant.price === 0) {
          priceHtml = "<span>-</span>";
        } else {
          var isOnSale =
            variant.compare_at_price && variant.compare_at_price > variant.price;
          priceHtml +=
            '<span class="' +
            (isOnSale ? "custom-saving-color" : "") +
            '">' +
            theme.Currency.formatMoney(
              variant.price,
              theme.settings.moneyFormat,
            ) +
            "</span>";
          if (isOnSale) {
            priceHtml +=
              ' <span class="grid-product__price--original">' +
              theme.Currency.formatMoney(
                variant.compare_at_price,
                theme.settings.moneyFormat,
              ) +
              "</span>";
          }
        }
        priceEl.innerHTML = priceHtml;
      }

      if (imageEl && variant.featured_image) {
        imageEl.src = theme.Images
          ? theme.Images.getSizedImageUrl(variant.featured_image.src, "300x300")
          : variant.featured_image.src;
      }
    } else {
      submitBtn.setAttribute("disabled", "disabled");
      submitText.textContent = theme.strings.selectSize || "Select size";
      if (priceEl && priceEl._qaOriginalPriceHtml !== undefined) {
        priceEl.innerHTML = priceEl._qaOriginalPriceHtml;
      }
    }
  }

  function updateAvailability(modal, productId, variants) {
    var selectedOptions = getSelectedOptions(modal, productId);
    var fieldsets = modal.querySelectorAll("[data-option-position]");

    fieldsets.forEach(function (fieldset, fieldsetIndex) {
      var inputs = fieldset.querySelectorAll(
        'input[data-quick-add-option="' + productId + '"]',
      );

      inputs.forEach(function (input) {
        var testOptions = selectedOptions.slice();
        testOptions[fieldsetIndex] = input.value;

        var hasAvailable = variants.some(function (v) {
          var matches = true;
          for (var i = 0; i < testOptions.length; i++) {
            if (testOptions[i] && v.options[i] !== testOptions[i]) {
              matches = false;
              break;
            }
          }
          return matches && v.available;
        });

        var label = input.nextElementSibling;
        if (label) {
          if (hasAvailable) {
            label.classList.remove("disabled");
          } else {
            label.classList.add("disabled");
          }
        }
      });
    });
  }

  function initPlayerSelect(modal, productId) {
    var select = modal.querySelector(
      '[data-quick-add-player="' + productId + '"]',
    );
    if (!select) return;

    var nameInput = modal.querySelector(
      '[data-quick-add-custom-name="' + productId + '"]',
    );
    var numberInput = modal.querySelector(
      '[data-quick-add-custom-number="' + productId + '"]',
    );

    select.removeEventListener("change", select._quickAddPlayerHandler);

    select._quickAddPlayerHandler = function () {
      var selected = select.options[select.selectedIndex];
      nameInput.value = selected.getAttribute("data-name") || "";
      numberInput.value = selected.getAttribute("data-number") || "";
    };

    select.addEventListener("change", select._quickAddPlayerHandler);
  }

  function initFormSubmit(modal, productId) {
    var form = modal.querySelector('[data-quick-add-form="' + productId + '"]');
    if (!form || form._quickAddBound) return;
    form._quickAddBound = true;

    form.addEventListener("submit", function (evt) {
      evt.preventDefault();

      var submitBtn = modal.querySelector(
        '[data-quick-add-submit="' + productId + '"]',
      );
      if (submitBtn.hasAttribute("disabled")) return;

      submitBtn.classList.add("btn--loading");

      var variantId = modal.querySelector(
        '[data-quick-add-variant-input="' + productId + '"]',
      ).value;
      var bodyParts = ["id=" + variantId, "quantity=1"];

      var customName = modal.querySelector(
        '[data-quick-add-custom-name="' + productId + '"]',
      );
      var customNumber = modal.querySelector(
        '[data-quick-add-custom-number="' + productId + '"]',
      );
      if (customName && customName.value) {
        bodyParts.push(
          "properties[custom_name]=" + encodeURIComponent(customName.value),
        );
      }
      if (customNumber && customNumber.value) {
        bodyParts.push(
          "properties[custom_number]=" + encodeURIComponent(customNumber.value),
        );
      }
      if (
        (customName && customName.value) ||
        (customNumber && customNumber.value)
      ) {
        var customizationEl = modal.querySelector(
          ".quick-add-modal__customization",
        );
        var isFree =
          customizationEl &&
          customizationEl.getAttribute("data-free-customization") === "true";
        if (!isFree) {
          bodyParts.push("properties[_customization]=yes");
        }
      }

      fetch(theme.routes.cartAdd, {
        method: "POST",
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          "X-Requested-With": "XMLHttpRequest",
        },
        body: bodyParts.join("&"),
      })
        .then(function (response) {
          return response.json();
        })
        .then(function (data) {
          submitBtn.classList.remove("btn--loading");

          if (data.status === 422) {
            var submitText = modal.querySelector(
              '[data-quick-add-submit-text="' + productId + '"]',
            );
            submitText.textContent = data.description || "Error";
            setTimeout(function () {
              submitText.textContent = theme.strings.addToCart || "Add to cart";
            }, 2000);
            return;
          }

          closeModal(modal);

          document.dispatchEvent(
            new CustomEvent("ajaxProduct:added", {
              detail: { product: data },
              bubbles: true,
            }),
          );
        })
        .catch(function () {
          submitBtn.classList.remove("btn--loading");
        });
    });
  }

  function initCarousel(modal, productId) {
    var carousel = modal.querySelector(
      '[data-quick-add-carousel="' + productId + '"]',
    );
    var dotsContainer = modal.querySelector(
      '[data-quick-add-dots="' + productId + '"]',
    );
    if (!carousel || !dotsContainer) return;

    var dots = dotsContainer.querySelectorAll(".quick-add-drawer__dot");
    if (dots.length < 2) return;

    carousel.scrollLeft = 0;

    var scrollTimer;
    carousel.addEventListener("scroll", function () {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(function () {
        var index = Math.round(carousel.scrollLeft / carousel.offsetWidth);
        dots.forEach(function (dot, i) {
          dot.classList.toggle("active", i === index);
        });
      }, 50);
    });

    dots.forEach(function (dot) {
      dot.addEventListener("click", function () {
        var index = parseInt(dot.getAttribute("data-slide-index"), 10);
        carousel.scrollTo({
          left: index * carousel.offsetWidth,
          behavior: "smooth",
        });
      });
    });

    var isDown = false;
    var startX = 0;
    var scrollStart = 0;
    var hasDragged = false;

    carousel.addEventListener("mousedown", function (e) {
      isDown = true;
      hasDragged = false;
      startX = e.pageX;
      scrollStart = carousel.scrollLeft;
      carousel.style.cursor = "grabbing";
      carousel.style.scrollSnapType = "none";
      e.preventDefault();
    });

    carousel.addEventListener("mousemove", function (e) {
      if (!isDown) return;
      var dx = e.pageX - startX;
      if (Math.abs(dx) > 5) hasDragged = true;
      carousel.scrollLeft = scrollStart - dx;
    });

    function endDrag() {
      if (!isDown) return;
      isDown = false;
      carousel.style.cursor = "";
      carousel.style.scrollSnapType = "";
      var slideWidth = carousel.offsetWidth;
      var target = Math.round(carousel.scrollLeft / slideWidth) * slideWidth;
      carousel.scrollTo({ left: target, behavior: "smooth" });
    }

    carousel.addEventListener("mouseup", endDrag);
    carousel.addEventListener("mouseleave", endDrag);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
